import React, {Component} from 'react';
import Slider from 'react-slick';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {
    login    
} from '../../actions/Index';
import {toastr} from 'react-redux-toastr';
import {langs} from '../../config/localization';
import {Loader} from "../Common/Loader";
import About from "../Common/About";

class UserGuideVideo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            toggleModal     : false,
            modalType       : '',
            username        : '',
            accessToken     : '',
            tokenType       : '',
            showLoader      : false
        };
    }    

    /**
     * Close modal
     */
    closeModal() {
        this.setState({toggleModal : false});
    }

    /**
     * Render the login form
     * @returns {*}
     */
    render(){
        const {handleSubmit} = this.props;
        const TopSliderSettings = {
            arrows: true,
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe:false,
            autoplay: false,
            responsive: [
                {
                breakpoint: 768,
                settings: {
                    arrows: true,
                }
            },
            
        ]
        };
        if(!this.state.showLoader) {
            return (
                <div>
                <section className="film-page">
                        <div>
                            <div className="film-slider" style={{backgroundImage:'url(assets/images/eathdeck/film_03.png)'}} >
                                <div className="banner-container">
                                    <div className="play-btn">
                                        <a href="#"><img src="assets/images/eathdeck/play-button.png" /></a>
                                    </div>
                                    <h4 className="banner-subtitle">
                                        Watch the film again, click at different parts<br/> and generate a new earthDECK.
                                    </h4>
                                    <div className="banner-btn">
                                        <ul>
                                            <li><a href="/play-film">PLAY</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                </section>   
                <About />               
                </div>
            );
        } else {
            return <Loader/>
        }
    }
}

/**
 * Form validations
 * @param values
 * @returns {{}}
 */
function validate(values){
    let errors = {};

    if(!values.username){
        errors.username = langs.validation_messages.email_username_required;
    }

    if(!values.password){
        errors.password = langs.validation_messages.password_required;
    }

    if(values.password && values.password.length > 32){
        errors.password = langs.validation_messages.password_length;
    }

    return errors;
}

export default reduxForm({
    validate,
    form: 'Login'
})(
    connect(null, {login})(UserGuideVideo)
);


// WEBPACK FOOTER //
// ./components/StaticPages/UserGuideVideo.js